import { blinkConstants } from '@thoughtspot/blink-constants';
import { getCurrentOrgId, getTSAdminUserGuid, isOrgUiEnabled, } from '@thoughtspot/session-service';
import { PrincipalVisibilityType } from "../../../../../../services/generated/graphql-types";
import { cleanUserPayload } from '../../utils';
export const canEditUserCredentials = (params) => {
    const { userId, userOrgIds, belongToAllOrgs, isAllOrgContext } = params;
    if (userId === getTSAdminUserGuid() &&
        !isAllOrgContext &&
        getCurrentOrgId() !== blinkConstants.orgs.MASTER_ID) {
        return false;
    }
    if (!isOrgUiEnabled() || isAllOrgContext)
        return true;
    return userOrgIds.size <= 1 && !belongToAllOrgs;
};
export var SubmitResult;
(function (SubmitResult) {
    SubmitResult["SUCCESS"] = "success";
    SubmitResult["NO_CHANGES"] = "no-changes";
    SubmitResult["ERROR"] = "error";
    SubmitResult["DUPLICATE_NAME"] = "duplicate-name";
})(SubmitResult || (SubmitResult = {}));
export const areSetsEqual = (setA, setB) => setA.size === setB.size && [...setA].every(id => setB.has(id));
export const hasUserDataChanged = (current, original, isClusterAdmin) => current.name !== original.name ||
    current.displayName !== original.displayName ||
    current.email !== original.email ||
    current.allowOthersToShare !== original.allowOthersToShare ||
    !areSetsEqual(current.groupIds, original.groupIds) ||
    (isClusterAdmin && !areSetsEqual(current.orgIds, original.orgIds));
export const buildUpdateContent = (details, form, selectedGroupIds, selectedOrgIds, isClusterAdmin) => {
    const { id, ...base } = details;
    const content = {
        ...base,
        displayName: form.displayName.trim(),
        visibility: form.allowOthersToShare
            ? PrincipalVisibilityType.Default
            : PrincipalVisibilityType.NonSharable,
        assignedGroups: isClusterAdmin
            ? details.assignedGroups ?? []
            : [...selectedGroupIds],
        userContent: {
            ...details.userContent,
            userProperties: {
                mail: form.email.trim(),
                frontendURL: window.location.hostname,
            },
        },
        header: {
            ...details.header,
            name: form.name,
            displayName: form.displayName.trim(),
            ...(isClusterAdmin &&
                isOrgUiEnabled() && {
                orgIds: [...selectedOrgIds].map(Number),
            }),
        },
    };
    return cleanUserPayload(content);
};
//# sourceMappingURL=utils.js.map